import { Dispatch, SetStateAction, useEffect, useState } from 'react';

const useHovered = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const onTouchEnd = () => {
      setTimeout(() => setHovered(false), 250);
    };

    document.addEventListener('touchend', onTouchEnd);
    document.addEventListener('click', onTouchEnd, true);

    return () => {
      document.removeEventListener('touchend', onTouchEnd);
      document.removeEventListener('click', onTouchEnd, true);
    };
  }, []);

  return [hovered, setHovered];
};

export default useHovered;
